import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { isNil } from 'ramda'
import classnames from 'classnames'

import { OverlayWithMyListButton } from './overlay-with-my-list-button'
import { DefaultOverlay } from './default-overlay'
import styles from './overlay.css'
import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import TILE_FRAGMENT from '../../../../../graphql/fragments/tile.gql'

const getOverlayComponent = (tile) => {
  switch (tile.contentItem.__typename) {
    case 'Title':
    case 'Series':
      return OverlayWithMyListButton
    default:
      return DefaultOverlay
  }
}

const TileOverlay = React.memo(({
  tile,
  display,
  tileType,
  isOnMyList,
  addToMyList,
  isRental,
  isCircular,
  renderedInComponent
}) => {
  const isAuthenticated = useIsAuthenticated()
  const OverlayComponent = getOverlayComponent(tile)
  const isDefaultOverlay = OverlayComponent === DefaultOverlay
  let overlay = null
  if (!isNil(OverlayComponent)) {
    overlay = (
      <OverlayComponent
        tile={tile}
        display={display}
        isAuthenticated={isAuthenticated}
        isOnMyList={isOnMyList}
        addToMyList={addToMyList}
        tileType={tileType}
        renderedInComponent={renderedInComponent}
      />
    )
  }

  const onOffClass = display ? styles.tileOverlayOn : styles.tileOverlayOff

  return (
    <div className={
      classnames(
        styles.tileOverlay,
        onOffClass,
        {
          [isRental ? styles.defaultRentalTileOverlay : styles.defaultTileOverlay]: isDefaultOverlay,
          [styles.circularFrame]: isCircular
        }
      )
    }
    >
      { overlay }
    </div>
  )
})

TileOverlay.propTypes = {
  tile: propType(TILE_FRAGMENT).isRequired,
  tileType: PropTypes.string,
  display: PropTypes.bool.isRequired,
  isOnMyList: PropTypes.bool,
  addToMyList: PropTypes.func.isRequired,
  isRental: PropTypes.bool,
  isCircular: PropTypes.bool,
  renderedInComponent: PropTypes.string
}

TileOverlay.defaultProps = {
  tileType: null,
  isOnMyList: false,
  isCircular: false,
  isRental: false,
  renderedInComponent: undefined
}

export default TileOverlay
